import Controller from "../Controller";

export default class IHSakaiMuchaController extends Controller {
  clearAllSelector () {
    super.clearAllSelector();
    this.ih.searchTargetTypes = [];
  }
}



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHSakaiMuchaController.js